// @generated by protoc-gen-connect-query v1.4.2
// @generated from file fingertip/creator/rating/v1/rating.proto (package fingertip.creator.rating.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { CreateSiteRatingPublicRequest, CreateSiteRatingPublicResponse, DeleteCustomerRatingRequest, DeleteCustomerRatingResponse, DeleteSiteRatingRequest, DeleteSiteRatingResponse, GetCustomerRatingsRequest, GetCustomerRatingsResponse, GetSiteContactRatingRequest, GetSiteContactRatingResponse, GetSiteRatingRequest, GetSiteRatingResponse, GetSiteRatingsRequest, GetSiteRatingsResponse } from "./rating_pb.js";

/**
 * @generated from rpc fingertip.creator.rating.v1.RatingService.GetSiteRating
 */
export const getSiteRating = {
  localName: "getSiteRating",
  name: "GetSiteRating",
  kind: MethodKind.Unary,
  I: GetSiteRatingRequest,
  O: GetSiteRatingResponse,
  service: {
    typeName: "fingertip.creator.rating.v1.RatingService"
  }
};

/**
 * @generated from rpc fingertip.creator.rating.v1.RatingService.DeleteSiteRating
 */
export const deleteSiteRating = {
  localName: "deleteSiteRating",
  name: "DeleteSiteRating",
  kind: MethodKind.Unary,
  I: DeleteSiteRatingRequest,
  O: DeleteSiteRatingResponse,
  service: {
    typeName: "fingertip.creator.rating.v1.RatingService"
  }
};

/**
 * @generated from rpc fingertip.creator.rating.v1.RatingService.GetSiteContactRating
 */
export const getSiteContactRating = {
  localName: "getSiteContactRating",
  name: "GetSiteContactRating",
  kind: MethodKind.Unary,
  I: GetSiteContactRatingRequest,
  O: GetSiteContactRatingResponse,
  service: {
    typeName: "fingertip.creator.rating.v1.RatingService"
  }
};

/**
 * @generated from rpc fingertip.creator.rating.v1.RatingService.GetSiteRatings
 */
export const getSiteRatings = {
  localName: "getSiteRatings",
  name: "GetSiteRatings",
  kind: MethodKind.Unary,
  I: GetSiteRatingsRequest,
  O: GetSiteRatingsResponse,
  service: {
    typeName: "fingertip.creator.rating.v1.RatingService"
  }
};

/**
 * @generated from rpc fingertip.creator.rating.v1.RatingService.CreateSiteRatingPublic
 */
export const createSiteRatingPublic = {
  localName: "createSiteRatingPublic",
  name: "CreateSiteRatingPublic",
  kind: MethodKind.Unary,
  I: CreateSiteRatingPublicRequest,
  O: CreateSiteRatingPublicResponse,
  service: {
    typeName: "fingertip.creator.rating.v1.RatingService"
  }
};

/**
 * @generated from rpc fingertip.creator.rating.v1.RatingService.DeleteCustomerRating
 */
export const deleteCustomerRating = {
  localName: "deleteCustomerRating",
  name: "DeleteCustomerRating",
  kind: MethodKind.Unary,
  I: DeleteCustomerRatingRequest,
  O: DeleteCustomerRatingResponse,
  service: {
    typeName: "fingertip.creator.rating.v1.RatingService"
  }
};

/**
 * @generated from rpc fingertip.creator.rating.v1.RatingService.GetCustomerRatings
 */
export const getCustomerRatings = {
  localName: "getCustomerRatings",
  name: "GetCustomerRatings",
  kind: MethodKind.Unary,
  I: GetCustomerRatingsRequest,
  O: GetCustomerRatingsResponse,
  service: {
    typeName: "fingertip.creator.rating.v1.RatingService"
  }
};
